module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-banner-2@2x-35c03f87ade09b76cdef35b3d403e5b5.png";